import React from 'react'
import _ from 'underscore'
import { MessageCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

class WhatsappButton extends React.Component {

  onClick = () => {
    this.props.onClick()
  }

  render() {
    return (
      <Button size="sm" variant="outline" title="Send Whatsapp" onClick={this.onClick}>
        <MessageCircle className="size-4" />
      </Button>
    )
  }
}

export default WhatsappButton
